
import React, { useState, useEffect, useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'
import AppContext from '../../contexts/AppContext'
import useToastContext from "../../hooks/useToastContext"

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';

import { CheckBoxField } from '../UI'

const stripePromise = loadStripe(process.env.MIX_STRIPE_PUBLIC_KEY);

const StripeElements = ({ id, type, header, clientSecret, creditsFirst }) => {

    const appearance = {
        theme: 'stripe',
    }

    const options = {
        appearance,
        clientSecret,
    }

    return (
        <>
            {header &&
                <>
                    <h3 className="text-center">{header}</h3>
                    <hr />
                </>
            }
            <Elements stripe={stripePromise} options={options}>
                <CheckoutForm
                    id={id}
                    type={type}
                    creditsFirst={creditsFirst}
                />
            </Elements>
            <hr />
            <div className="mt-3 text-center">
                <div className="col-md-8 mx-auto">
                    <small>
                        <FontAwesomeIcon
                            icon={faExclamationTriangle}
                            className="me-2"
                        />
                        <b>Warning:</b> Do not place inappropriate ads or anything to do with drugs, sexual/adult content, guns or ammo. These are prohibited ads for our website and we do not allow them. If you load money to your account and create an ad of this type you will not receive a refund for the money you've spent for these types of ad(s). If you create a fraudulent ad you will not get a refund.
                    </small>
                </div>
            </div>
        </>
    )
}

const CheckoutForm = ({ id, type, clientSecret, creditsFirst }) => {

    const stripe = useStripe()
    const elements = useElements()

    const appContext = useContext(AppContext)
    const { bannerServices, postServices } = appContext

    const [ message, setMessage ] = useState(null)
    const [ isLoading, setIsLoading ] = useState(false)

    const addToast = useToastContext()

    useEffect(() => {
        if (!stripe){
            return;
        }
        if (!clientSecret){
            return;
        }

        stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
            switch (paymentIntent.status) {
                case "succeeded":
                    setMessage("Payment succeeded!");
                    break;
                case "processing":
                    setMessage("Your payment is processing.");
                    break;
                case "requires_payment_method":
                    setMessage("Your payment was not successful, please try again.");
                    break;
                default:
                    setMessage("Something went wrong.");
                    break;
            }
        });

    }, [ stripe ]);

    const handleSubmit = e => {
        e.preventDefault()

        if (!stripe || !elements) return null

        if(type == 'banner'){
            setIsLoading(true)
            return bannerServices.purchase(id, creditsFirst ? 'stripe-credits-first' : 'stripe').then(res => {
                stripe.confirmPayment({
                    elements,
                    confirmParams: {
                        return_url: `${process.env.MIX_APP_URL}/banner/payment-complete/${id}`
                    },
                }).then(({ error }) => {
                    if (error.type === "card_error" || error.type === "validation_error") {
                        setMessage(error.message)
                    } else {
                        setMessage("An unexpected error occured.")
                    }
                    setIsLoading(false)
                })
            }).catch(res => {
                setIsLoading(false)
                const message = res && res.data && res.data.message
                if(message) addToast({title: 'Error', message: message, type: 'danger'})
                onError(res)
            })
        }

        if(type == 'post'){
            setIsLoading(true)
            return postServices.purchase(id, creditsFirst ? 'stripe-credits-first' : 'stripe').then(res => {
                stripe.confirmPayment({
                    elements,
                    confirmParams: {
                        return_url: `${process.env.MIX_APP_URL}/post/payment-complete/${id}`
                    },
                }).then(({ error }) => {
                    if (error.type === "card_error" || error.type === "validation_error") {
                        setMessage(error.message)
                    } else {
                        setMessage("An unexpected error occured.")
                    }
                    setIsLoading(false)
                })
            }).catch(res => {
                setIsLoading(false)
                const message = res && res.data && res.data.message
                if(message) addToast({title: 'Error', message: message, type: 'danger'})
                onError(res)
            })
        }

    };

    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            {message &&
                <div id="payment-message" className="alert alert-danger">{message}</div>
            }

            <PaymentElement
                id="payment-element"
                onFocus={() => setMessage(null)}
            />

            <div className="mt-3 text-center">
                <button
                    id="submit"
                    disabled={isLoading || !stripe || !elements}
                    className="btn btn-lg btn-success"
                >
                    <span id="button-text">
                        {isLoading ? <FontAwesomeIcon icon={faSpinner} spin /> : "Pay now"}
                    </span>
                </button>
            </div>

        </form>
    );
};


export {
    StripeElements,
    CheckoutForm
}